export default {
  setStaticMedia (state, payload = []) {
    state.staticMedia = payload
  },
  setStaticMediaLoading (state, payload) {
    state.staticMediaLoading = payload
  }
}
